const DATA_TEST_IDS = {
  fragmentsNewPasswordFragment:
    'authentication__recovery_new-password-fragment',
} as const;

export default DATA_TEST_IDS;
